import { render } from "./ProductImage.vue?vue&type=template&id=2acb28d6&lang=pug"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__